<template lang="pug" src="./LazyCategoryProducts/template.pug"></template>

<script>
import LazyCategoryProducts from './LazyCategoryProducts';

import { get, cloneDeep } from '@/helpers';

export default {
    name: 'LazyProductList',
    extends: LazyCategoryProducts,
    methods: {
        refetch() {
            this.loading = true;

            const shop = get(this.cms, 'shop.id');
            let products = [];

            let ids = [];
            if ((products = get(this.section, 'products'))) {
                ids = products.map(product => product.id);
            }

            if (!ids.length) {
                this.products.loading = false;
                this.loading = false;
                return;
            }

            const payload = {
                pageInfo: {
                    currentPage: this.currentPage,
                    perPage: 6
                },
                filters: [
                    {
                        key: 'shop',
                        match: shop.toString()
                    },
                    {
                        key: 'status',
                        match: 'enabled'
                    },
                    {
                        key: 'ids',
                        in: ids
                    },
                    {
                        key: 'qty_sum',
                        from: 1
                    }
                ],
                order: 'date' // property:groupsort
            };

            this.fetchProducts(payload)
                .then(response => {
                    if (response.pageInfo.currentPage > response.pageInfo.lastPage) {
                        this.changePage(response.pageInfo.lastPage);
                        return;
                    }

                    const products = cloneDeep(response);
                    const container = document.querySelector('.preorder-columns > .column.left > .ps');
                    if (container) container.scrollTop = 0;

                    if (products.items && products.items.length) {
                        products.items.forEach((product, i) => {
                            product.position = i + 1;
                        });
                    }

                    this.products = products;
                    // this.insertProducts({ products });
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
};
</script>
